export default __webpack_public_path__ + "static/media/gallery_13.be3cd220.jpg";